import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { useSpring, animated } from 'react-spring';
import Rheostat from 'rheostat';
import 'rheostat/initialize';
import '../../../style/rheostat.css';
import FilterHeader from './FilterHeader';
import { neutral } from '../../../style/colors';

const FilterSlider = (props: IFilterSliderPropTypes) => {
  const {
    icon,
    onValueChange,
    title,
    valueDenomination,
    values,
    minValue,
    maxValue,
    toggled,
    setToggled,
    className,
    onIconClick,
    height,
    iconToggled,
  } = props;
  const [display, setDisplay] = useState('block');
  const minValueLeft = ((values[0] - minValue) / (maxValue - minValue)) * 100;
  const maxValueLeft = ((values[1] - minValue) / (maxValue - minValue)) * 100;
  const filterAnimation = useSpring({
    display,
    opacity: toggled ? 1 : 0,
    height: toggled ? (height ? `${height}px` : '110px') : '0px',
    onRest: () => {
      if (!toggled) {
        setDisplay('none');
      }
    },
    onStart: () => {
      if (toggled) {
        setDisplay('block');
      }
    },
  });

  return (
    <div className={className}>
      <FilterHeader
        title={title}
        icon={icon}
        iconToggled={iconToggled}
        onIconClick={onIconClick}
        toggled={toggled}
        onClick={() => setToggled(!toggled)}
      />
      <animated.div
        style={{
          ...{
            display: 'flex',
            overflow: 'hidden',
            padding: '0 38px',
            borderBottom: `1px solid ${neutral[200]}`,
          },
          ...filterAnimation,
        }}
      >
        {props.children}
        <Values>
          <MinValue>-{minValue}</MinValue>
          <MaxValue>{maxValue}</MaxValue>
          <CurrentLabels>
            <MinCurrentLabel
              left={
                maxValueLeft - minValueLeft < 15
                  ? `calc(${minValueLeft}% - 35px)`
                  : `calc(${minValueLeft}% - 20px)`
              }
            >
              {values[0] === 1970 ? '-1970' : values[0]}
              {valueDenomination}
            </MinCurrentLabel>
            <MaxCurrentLabel
              left={
                maxValueLeft - minValueLeft < 15
                  ? `calc(${maxValueLeft}% - 5px)`
                  : `calc(${maxValueLeft}% - 35px)`
              }
            >
              {values[1]}
              {valueDenomination}
            </MaxCurrentLabel>
          </CurrentLabels>
        </Values>
        <Rheostat
          min={minValue}
          max={maxValue}
          values={values}
          onChange={a => onValueChange(a.values)}
        // onValuesUpdated={a => onValueChange(a.values)}
        />
      </animated.div>
    </div>
  );
};

const Values = styled.div`
  position: relative;
  height: 30px;
  margin: 10px -25px;
  font-size: 14px;
`;
const MinValue = styled.div`
  position: absolute;
  left: 10px;
  color: ${neutral[400]};
`;
const MaxValue = styled.div`
  position: absolute;
  right: 17px;
  color: ${neutral[400]};
`;
const CurrentLabels = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0 27px;
`;
const MinCurrentLabel = styled.div`
  position: absolute;
  z-index: 2;
  display: flex;
  justify-content: center;
  background-color: ${neutral[200]};
  border-radius: 5px;
  padding: 2px 6px;
  font-weight: 600;
  ${props =>
    css`
      left: ${props.left};
    `}
`;
const MaxCurrentLabel = styled.div`
  position: absolute;
  z-index: 2;
  display: flex;
  justify-content: center;
  background-color: ${neutral[200]};
  border-radius: 5px;
  padding: 2px 6px;
  font-weight: 600;
  ${props =>
    css`
      left: ${props.left};
    `}
`;
interface IFilterSliderPropTypes {
  title: string;
  icon: any;
  onValueChange: Function;
  valueDenomination: string | JSX.Element;
  values: Array<number>;
  minValue: number;
  maxValue: number;
  toggled: boolean;
  setToggled: Function;
  className?: string;
  onIconClick?: Function;
  children?: any;
  height?: number;
  iconToggled: boolean;
}

export default FilterSlider;
